module.exports = __webpack_public_path__ + "img/img_4.4cb31db6.png";